module.exports = __webpack_public_path__ + "img/88.3.TP.fe78b5be.png";